import type { Permission, User } from "../types";

export function isAdmin(user: User | null | undefined): boolean {
  return !!user && user.role === "admin";
}

export function hasPermission(
  user: User | null | undefined,
  perm: Permission,
): boolean {
  if (!user) return false;
  if (user.role === "admin") return true;
  return user[perm] === true;
}
